if (!customElements.get('cart-discounts')) {
  class CartDiscounts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.input = this.querySelector('input');
      this.button = this.querySelector('button');

      if (!this.input || !this.button) return;

      this.button.addEventListener('click', this.applyDiscount.bind(this));
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.applyDiscount();
        }
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: 'main-cart',
          selector: '.js-cart-items',
        },
        {
          id: 'cart-summary',
          section: 'main-cart',
          selector: '.js-subtotal',
        },
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section',
        },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }

    applyDiscount() {
      const code = this.input.value.trim();
      if (!code) return;

      this.button.classList.add('loading');

      const sections = this.getSectionsToRender();
      const body = JSON.stringify({
        discount: code,
        sections: sections.map((s) => s.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body,
      })
        .then((response) => response.json())
        .then((state) => {
          // Update sections
          sections.forEach((section) => {
            const target =
              document.getElementById(section.id)?.querySelector(section.selector) ||
              document.getElementById(section.id);

            if (state.sections && target) {
              const newHTML = this.getSectionInnerHTML(state.sections[section.section], section.selector);
              if (newHTML) target.innerHTML = newHTML;
            }
          });

          // Clear input and loading state
          this.input.value = '';
          this.button.classList.remove('loading');

          // Publish cart update for other components
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-discounts', cartData: state });
          }
        })
        .catch((err) => {
          console.error('Discount error:', err);
          this.button.classList.remove('loading');
        });
    }
  }

  customElements.define('cart-discounts', CartDiscounts);
}
